import { AuthError, PublicClientApplication } from '@azure/msal-browser';

import { authConfigured, msalConfig } from '@/auth/config';

export enum MsalErrorCodes {
  UserForgotPassword = 'AADB2C90118',
  UserHasCancelled = 'AADB2C90091',
}

export function isErrorCode(errorCode: MsalErrorCodes, authError: AuthError): boolean {
  const { errorMessage } = authError;

  return errorMessage.indexOf(errorCode) > -1;
}

/**
 * The MSAL instance is only constructed when B2C is configured (see
 * {@link authConfigured}). Consumers that touch it directly must run behind an
 * `authConfigured` check or use {@link requireMsal}; the React tree does this by
 * only mounting the msal-hook components inside a configured `MsalProvider`.
 */
export const msalInstance: PublicClientApplication | null = authConfigured
  ? new PublicClientApplication(msalConfig)
  : null;

export function requireMsal(): PublicClientApplication {
  if (!msalInstance) {
    throw new Error('MSAL is not configured in this environment');
  }

  return msalInstance;
}
